import React, { useState } from 'react';
import Icon from '../../../components/appIcon';
import Image from '../../../components/appImage';
import Button from '../../../components/ui/button';
import { Checkbox } from '../../../components/ui/checkbox';
const BACKEND_URL = import.meta.env.VITE_API_URL;

const EmployeeTable = ({
  employees,
  selectedEmployees,
  onSelectEmployee,
  onSelectAll,
  onEditEmployee,
  onViewEmployee,
  onUploadPhoto,
  onToggleStatus,
  sortConfig,
  onSort,
  departments
}) => {
  const [hoveredRow, setHoveredRow] = useState(null);

  const getSortIcon = (column) => {
    if (sortConfig?.key !== column) {
      return <Icon name="ArrowUpDown" size={16} className="text-muted-foreground" />;
    }
    return sortConfig?.direction === 'asc'
      ? <Icon name="ArrowUp" size={16} className="text-primary" />
      : <Icon name="ArrowDown" size={16} className="text-primary" />;
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { color: 'bg-success/10 text-success border-success/20', label: 'Active' },
      inactive: { color: 'bg-muted text-muted-foreground border-border', label: 'Inactive' },
      suspended: { color: 'bg-error/10 text-error border-error/20', label: 'Suspended' }
    };

    const config = statusConfig?.[status] || statusConfig?.inactive;
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${config?.color}`}>
        <div className={`w-1.5 h-1.5 rounded-full mr-1.5 ${status === 'active' ? 'bg-success' : status === 'suspended' ? 'bg-error' : 'bg-muted-foreground'}`}></div>
        {config?.label}
      </span>
    );
  };

  const getEmploymentTypeBadge = (type) => {
    const typeConfig = {
      permanent: { color: 'bg-primary/10 text-primary border-primary/20', label: 'Permanent' },
      temprory: { color: 'bg-warning/10 text-warning border-warning/20', label: 'Temprory' },
    };

    const config = typeConfig?.[type] || typeConfig?.temprory;
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${config?.color}`}>
        {config?.label}
      </span>
    );
  };

  const formatLastActivity = (timestamp) => {
    const now = new Date();
    const activity = new Date(timestamp);
    const diffInHours = Math.floor((now - activity) / (1000 * 60 * 60));

    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    if (diffInHours < 168) return `${Math.floor(diffInHours / 24)}d ago`;
    return activity?.toLocaleDateString();
  };

  const getDepartmentName = (departmentId) => {
    if (!departmentId) return 'N/A';
    const department = departments.find(dept => dept.id === departmentId || dept.name === departmentId);
    return department ? department.name : departmentId;
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden enterprise-shadow-card">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="w-12 px-4 py-3">
                <Checkbox
                  checked={selectedEmployees?.length === employees?.length && employees?.length > 0}
                  onChange={(e) => onSelectAll(e?.target?.checked)}
                  indeterminate={selectedEmployees?.length > 0 && selectedEmployees?.length < employees?.length}
                />
              </th>
              <th className="text-left px-4 py-3 text-sm font-medium text-foreground">
                <button
                  onClick={() => onSort('name')}
                  className="flex items-center space-x-2 hover:text-primary enterprise-transition"
                >
                  <span>Employee</span>
                  {getSortIcon('name')}
                </button>
              </th>
              <th className="text-left px-4 py-3 text-sm font-medium text-foreground">
                <button
                  onClick={() => onSort('department')}
                  className="flex items-center space-x-2 hover:text-primary enterprise-transition"
                >
                  <span>Department</span>
                  {getSortIcon('department')}
                </button>
              </th>
              <th className="text-left px-4 py-3 text-sm font-medium text-foreground">
                <button
                  onClick={() => onSort('date_of_join')}
                  className="flex items-center space-x-2 hover:text-primary enterprise-transition"
                >
                  <span>Date Of Join</span>
                  {getSortIcon('date_of_join')}
                </button>
              </th>
              <th className="text-left px-4 py-3 text-sm font-medium text-foreground">
                <button
                  onClick={() => onSort('employeeType')}
                  className="flex items-center space-x-2 hover:text-primary enterprise-transition"
                >
                  <span>Type</span>
                  {getSortIcon('employeeType')}
                </button>
              </th>
              <th className="text-left px-4 py-3 text-sm font-medium text-foreground">
                <button
                  onClick={() => onSort('status')}
                  className="flex items-center space-x-2 hover:text-primary enterprise-transition"
                >
                  <span>Status</span>
                  {getSortIcon('status')}
                </button>
              </th>
              <th className='text-left px-4 py-3 text-sm font-medium text-foreground'>Employee</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-foreground">
                <button
                  onClick={() => onSort('created_at')}
                  className="flex items-center space-x-2 hover:text-primary enterprise-transition"
                >
                  <span>Last Active</span>
                  {getSortIcon('created_at')}
                </button>
              </th>
              <th className="text-right px-4 py-3 text-sm font-medium text-foreground">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {employees?.map((employee) => {
              console.log("table employee",employee)
              return(
              <tr
                key={employee?.employee_id}
                className={`hover:bg-muted/30 enterprise-transition cursor-pointer ${selectedEmployees?.includes(employee?.employee_id) ? 'bg-primary/5' : ''
                  }`}
                onMouseEnter={() => setHoveredRow(employee?.employee_id)}
                onMouseLeave={() => setHoveredRow(null)}
                onClick={() => onViewEmployee(employee)}
              >
                <td className="px-4 py-4" onClick={(e) => e?.stopPropagation()}>
                  <Checkbox
                    checked={selectedEmployees?.includes(employee?.employee_id)}
                    onChange={(e) => onSelectEmployee(employee?.employee_id, e?.target?.checked)}
                  />
                </td>
                <td className="px-4 py-4">
                  <div className="flex items-center space-x-3">
                    <div className="relative">
                      <Image
                        src={employee?.images?.[0]
                          ? `${BACKEND_URL}${employee?.images[0]?.imagePath}`
                          : `${BACKEND_URL}${employee?.image1}` ? `${BACKEND_URL}${employee?.image1}` : `https://via.placeholder.com/150?text=Profile`}
                        alt={`${employee?.first_name} ${employee?.last_name}`}
                        className="w-10 h-10 rounded-full object-cover border border-border"
                      />
                      {employee?.status === 'active' && (
                        <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-success border-2 border-card rounded-full"></div>
                      )}
                    </div>
                    <div>
                      <div className="font-medium text-foreground">
                        {employee?.first_name} {employee?.last_name}
                      </div>
                      <div className="text-sm text-muted-foreground font-mono">{employee?.employee_id}</div>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-4">
                  <div className="text-sm text-foreground">{getDepartmentName(employee?.department)}</div>
                </td>
                <td className="px-4 py-4">
                  <div className="text-sm text-foreground">{employee?.date_of_join ? employee?.date_of_join.split("T")[0] : ""}</div>
                </td>
                <td className="px-4 py-4">
                  {getEmploymentTypeBadge(employee?.employee_type)}
                </td>
                <td className="px-4 py-4">
                  {getStatusBadge(employee?.status)}
                </td>
                <td>
                  {employee?.isUnkown ? (
                    <span className="px-2 py-1 text-xs rounded-full bg-purple-100 text-purple-800">
                      Unknown
                    </span>
                  ) : (
                    <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800">
                      Known
                    </span>
                  )}
                </td>
                <td className='px-4 py-4 text-right'>
                  {employee?.created_at && (
                    <span className="text-sm text-muted-foreground">
                      Last Active: {formatLastActivity(employee?.created_at)}
                    </span>
                  )}
                </td>
                <td className="px-4 py-4" onClick={(e) => e?.stopPropagation()}>
                  <div className="flex items-center justify-end space-x-1">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onEditEmployee(employee)}
                      className="h-8 w-8"
                      title="Edit employee"
                    >
                      <Icon name="Edit" size={16} />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onToggleStatus(employee)}
                      className={`h-8 w-8 ${employee?.status === 'active' ? 'text-error hover:text-error' : 'text-success hover:text-success'}`}
                      title={employee?.status === 'active' ? 'Deactivate employee' : 'Activate employee'}
                    >
                      <Icon name={employee?.status === 'active' ? 'UserX' : 'UserCheck'} size={16} />
                    </Button>
                  </div>
                </td>
              </tr>
            )})}
          </tbody>
        </table>
      </div>
      {employees?.length === 0 && (
        <div className="text-center py-12">
          <Icon name="Users" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h3 className="text-lg font-medium text-foreground mb-2">No employees found</h3>
          <p className="text-muted-foreground mb-4">No employees match your current filters.</p>
          <Button variant="outline" onClick={() => window.location?.reload()}>
            <Icon name="RefreshCw" size={16} className="mr-2" />
            Refresh
          </Button>
        </div>
      )}
    </div>
  );
};

export default React.memo(EmployeeTable);